import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-817dc334"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom" }
const _hoisted_2 = {
  key: 1,
  class: "custom-main"
}
const _hoisted_3 = { class: "textLink" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "面试邀请", -1))
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin":"30px 0 15px 0"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "demonstration",
  style: {"width":"90px"}
}, "起止时间", -1))
const _hoisted_8 = { style: {"display":"flex","align-items":"center","font-size":"12px","margin":"0 0 15px 90px"} }
const _hoisted_9 = { style: {"font-size":"16px","font-weight":"500","color":"#409EFF","margin":"0 5px"} }
const _hoisted_10 = {
  key: 0,
  style: {"display":"flex","align-items":"center","font-size":"12px","margin":"0 0 15px 90px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*本次面试系统自动赠送您60分钟直播时长", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "custom-footer" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: "icon icon-custom",
      title: "面试邀请",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)))
    }),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: {"position":"fixed","background":"rgba(0,0,0,.2)","left":"0","right":"0","bottom":"0","top":"0","margin":"auto","z-index":"4"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("i", {
              class: "icon icon-close btn-close",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.value1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value1) = $event)),
                type: "datetimerange",
                "range-separator": "To",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "disabled-date": _ctx.disabledDateFun,
                onChange: _ctx.handleTimeChange
              }, null, 8, ["modelValue", "disabled-date", "onChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createTextVNode("*您的直播剩余时间还有"),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.interviewMins), 1),
              _createTextVNode("分钟 ")
            ]),
            _createElementVNode("div", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.user_live_buys())),
              style: {"height":"24px","display":"flex","align-items":"center","justify-content":"center","color":"#fff","background":"#F56C6C","border-radius":"2px","margin-left":"6px","font-size":"12px","padding":"0 10px","cursor":"pointer"}
            }, " 立即购买直播时间")
          ]),
          (_ctx.interviewCount == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-default",
              style: {"cursor":"pointer"},
              disabled: !_ctx.custom.data && !_ctx.custom.description && _ctx.custom.extension,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, _toDisplayString(_ctx.$t('发送邀请')), 9, _hoisted_14)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "mask",
          onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args)), ["self"]))
        }))
      : _createCommentVNode("", true)
  ]))
}